<div mat-dialog-header>
  <h1>{{ headline }}</h1>
</div>
<mat-dialog-content #scroll class="dialog-container password">
  @if (!reset && !submitted) {
    <div class="row col-12">
      <p class="w-100">{{ content }}</p>
    </div>
  }
  <ng-container>
    <form #passwordForm="ngForm">
      @if (!reset && !submitted) {
        <mat-form-field class="w-100">
          <mat-label>Please enter your username</mat-label>
          <input
            matInput
            name="uname"
            [placeholder]="'Please enter your username'"
            [required]="required"
            [(ngModel)]="username"
          />
          <mat-error>This field is required</mat-error>
        </mat-form-field>
      }
      @if (reset) {
        <mat-form-field class="w-100">
          <mat-label>New Password</mat-label>
          <input
            #newPass="ngModel"
            matInput
            name="newPass"
            type="password"
            appStrongPassword="2"
            [placeholder]="'New Password'"
            [required]="required"
            [(ngModel)]="nPass"
          />
          @if (newPass.errors?.required) {
            <mat-error>This field is required</mat-error>
          }
          @if (newPass.errors?.noMatch) {
            <mat-error>Passwords do not match.</mat-error>
          }
        </mat-form-field>
        <app-strength-meter [password]="newPass.value" />
        @if (newPass.errors?.strongPassword) {
          <app-password-feedback
            [feedback]="newPass.errors.strongPassword.feedback"
          />
        }
        <mat-form-field class="w-100 verify">
          <mat-label>Verify New Password</mat-label>
          <input
            #verifyPass="ngModel"
            matInput
            name="verifyPass"
            type="password"
            [placeholder]="'Verify New Password'"
            [required]="required"
            [(ngModel)]="vPass"
          />
          @if (verifyPass.errors?.required) {
            <mat-error>This field is required</mat-error>
          }
          @if (verifyPass.errors?.noMatch) {
            <mat-error>Passwords do not match.</mat-error>
          }
        </mat-form-field>
      }
    </form>
  </ng-container>
  <div class="submitted" [hidden]="!submitted">
    @if (!reset) {
      <p class="reset-message">
        A temporary password has been sent to the email address on file.
      </p>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions class="row buttons">
  <button type="button" mat-raised-button color="accent" (click)="savePass()">
    {{ confirm }}
  </button>
  <button type="button" mat-raised-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
